import { lazy } from '@/service/lazy'

export default [{
  name: 'Perfis',
  path: 'perfil',
  id: 'perfil',
  icon: 'fa fa-group',
  component: lazy('app/default/gerenciador/perfil/index'),
  meta: { requireAuth: true, rules: ['gerenciar_perfil'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/perfil.js